import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bgColors500 } from '@/utils/stringToTailwindClass';

export default function ForumHeader({forum}) {

    return (
        forum && (
            <div className="flex flex-col gap-1 mb-10 border border-gray-400 p-3">
                <div className="flex flex-row items-center gap-3 justify-between">
                    <h1 className="text-base text-primary hover:underline"><Link to={`/forums/${forum.id}`}>{forum?.name}</Link></h1>
                    <div className='flex flex-row gap-2 items-center'>
                        { forum?.groups?.map((group, i) => {
                            const textColor = group.color ? `text-white` : "text-secondary";
                            return (
                                <span key={i} className={`text-xs border rounded-md px-2 py-1 ${bgColors500[group.color]} ${textColor} border-0`} lang="fr">
                                    {group.name}
                                </span>
                            )
                        })}
                    </div>
                </div>
                <span className="text-gray-500 text-xs" lang="fr">{forum?.description}</span>
            </div>
        )
    )
}

ForumHeader.propTypes = {
    forum: PropTypes.object
};